import React from 'react'
import styles from './loader.module.css'
import searchGif from "../../assets/img/searching.gif";

export default function Loader() {
    return <div className={styles.searching}>
        <img src={searchGif} width='40%'/>
    </div>
}